// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.buttons>.b-tooltip[data-v-c68d7ca2] {\n  margin-right: .5rem;\n  margin-bottom: .5rem;\n}\n", ""]);
// Exports
module.exports = exports;
